<template>
  <div class="card mb-3 border-0 rounded-0 bg-white letter-spacing">
    <div class="card-body">
      <!-- <h5>{{ reception.note_ref }}</h5> -->
      <p>
        Date de création :
        <b v-if="reception.created_at"> {{ getDate(reception.created_at) }}</b> |
        <b> {{ reception.note_type }} </b>
      </p>
    </div>
  </div>

  <div class="card mb-3 border-0 rounded-0 bg-white letter-spacing">
    <div class="card-header pb-3">
      <h5>Liste des Colis Ajoutés</h5>
    </div>
    <div class="card-body">
      <div class="mb-3">
        <div class="row">
          <div class="col-12">
            <div class="custom-search d-flex justify-content-end">
              <div class="form-group mb-0">
                <div class="d-flex align-items-center">
                  <input
                    type="text"
                    class="form-control d-inline-block"
                    placeholder="Chercher"
                    v-model="searchTerm"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <vue-good-table
        :columns="columns"
        :rows="rows1"
        :search-options="{
          enabled: true,
          externalQuery: searchTerm,
        }"
        responsive
      >
        <template #emptystate>
          <center>Aucune entrées correspondants trouvés</center>
        </template>
        <template #table-row="props">
          <template v-if="props.column.field === 'code'">
            <h6 class="text-warning" v-if="props.row.replace == 1">
              {{ props.row.code }}
              <i class="flaticon-refresh"></i>
            </h6>
            <h6 class="text-info" v-else-if="props.row.partial == 1">
              {{ props.row.code }}
              <i class="flaticon-corner-down-left"></i>
            </h6>
            <h6 v-else>
              {{ props.row.code }}
            </h6>
          </template>
          <template v-else-if="props.column.field === 'status'">
            <div
              v-if="
                props.row.status == 'IN_PROGRESS' &&
                props.row.status_second &&
                globalStore.globalHelper(props.row.status_second).name
              "
              class="rounded-pill fs-13 badge text-bg-black custom-badge"
              :style="{
                '--dynamic-bg': globalStore.globalHelper(props.row.status_second).code_color,
              }"
            >
              {{ globalStore.globalHelper(props.row.status_second).name }}
            </div>
            <div
              v-else
              class="rounded-pill fs-13 badge text-bg-black custom-badge"
              :style="{ '--dynamic-bg': props.row.code_color }"
            >
              {{ props.row.s_name }}
            </div>
          </template>
          <template v-else-if="props.column.field === 'price'">
            <b>{{ props.row.price }}</b> DH
          </template>
          <template v-else-if="props.column.field === 'updated_at'">
            <span class="text-nowrap">
              {{ getDate(props.row.updated_at) }}
            </span>
            </template>
            <span v-else-if="props.column.field === 'actions'">
               <div class="dropdown">
                  <button
                    class="dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i class="flaticon-dots"></i>
                  </button>
                  <ul class="dropdown-menu">
                    <!-- Ticket -->
                    <!-- <li>
                      <button
                        class="dropdown-item d-flex align-items-center"
                        @click="TicketsPDF( props.row.id )"
                      >
                        <i
                          class="flaticon-printing lh-1 me-8 position-relative top-1"
                        ></i>
                        Ticket
                      </button>
                    </li> -->

                    <!-- Historique -->
                    <li>
                      <button
                        class="dropdown-item d-flex align-items-center"
                        @click="showDetailSuivi(props.row)"
                      >
                        <i
                          class="flaticon-clock lh-1 me-8 position-relative top-1"
                        ></i>
                        Historique
                      </button>
                    </li>

                    <!-- Infos -->
                    <li>
                      <button
                        class="dropdown-item d-flex align-items-center"
                        @click="showDetails(props.row)"
                      >
                        <i
                          class="flaticon-view lh-1 me-8 position-relative top-1"
                        ></i>
                        Infos
                      </button>
                    </li>
                    <!-- Update -->
                    <li
                      v-if="
                        auth.can('PARCELS') &&
                        (user?.role_id === 1 || user?.role_id === 2) &&
                        props.row.status !== 'NEW_PARCEL' &&
                        props.row.status !== 'WAITING_PICKUP' &&
                        props.row.status !== 'RETURNED' &&
                        props.row.status !== 'RETURNED_PARTIAL'
                      "
                    >
                      <a
                        class="dropdown-item d-flex align-items-center"
                        href="javascript:void(0);"
                        @click="showUpdate(props.row)"
                      >
                        <i
                          class="flaticon-pen lh-1 me-8 position-relative top-1"
                        ></i>
                        Modifier
                      </a>
                    </li>
                    
                  </ul>
                </div>
            </span>
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>
    </div>
  </div>

  <div class="card mb-3 border-0 rounded-0 bg-white letter-spacing">
    <div class="card-header pb-3">
      <h5>Scan code suivi</h5>
    </div>
    <div class="card-body">
      <form @submit.prevent="SearchColis">
        <div class="custom-search">
          <div class="row">
            <div class="col-md-9">
              <div class="form-group">
                <label>Code Suivi :</label>
                <input
                  type="text"
                  class="form-control d-inline-block"
                  placeholder="Code Suivi"
                  v-model="codeColis"
                />
              </div>
            </div>
            <div class="col-md-3 d-flex align-items-end">
              <button
                type="submit"
                class="btn btn-success buttons"
                style="margin-right: 12px"
              >
                 <i class="ph ph-scan"></i>
              </button>
              
            </div>
            <div class="col-12">
              <hr />
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>

  <div class="card mb-3 border-0 rounded-0 bg-white letter-spacing">
    <div class="card-header pb-3">
      <h5>Liste des Colis Ramassés</h5>
    </div>
    <div class="card-body">
      <div class="mb-3">
        <div class="row">
          <div class="col-12">
            <div class="custom-search d-flex justify-content-end">
              <div class="form-group mb-0">
                <div class="d-flex align-items-center">
                  <input
                    type="text"
                    class="form-control d-inline-block"
                    placeholder="Chercher"
                    v-model="searchTerm1"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <vue-good-table
        :columns="columns"
        :rows="rows2"
        :search-options="{
          enabled: true,
          externalQuery: searchTerm1,
        }"
        responsive
      >
        <template #emptystate>
          <center>Aucune entrées correspondants trouvés</center>
        </template>
        <template #table-row="props">
          <template v-if="props.column.field === 'code'">
            <h6 class="text-warning" v-if="props.row.replace == 1">
              {{ props.row.code }}
              <i class="flaticon-refresh"></i>
            </h6>
            <h6 class="text-info" v-else-if="props.row.partial == 1">
              {{ props.row.code }}
              <i class="flaticon-corner-down-left"></i>
            </h6>
            <h6 v-else>
              {{ props.row.code }}
            </h6>
          </template>
          <template v-else-if="props.column.field === 'status'">
            <div
              v-if="
                props.row.status == 'IN_PROGRESS' &&
                props.row.status_second &&
                globalStore.globalHelper(props.row.status_second).name
              "
              class="rounded-pill fs-13 badge text-bg-black custom-badge"
              :style="{
                '--dynamic-bg': globalStore.globalHelper(props.row.status_second).code_color,
              }"
            >
              {{ globalStore.globalHelper(props.row.status_second).name }}
            </div>
            <div
              v-else
              class="rounded-pill fs-13 badge text-bg-black custom-badge"
              :style="{ '--dynamic-bg': props.row.code_color }"
            >
              {{ props.row.s_name }}
            </div>
          </template>
          <template v-else-if="props.column.field === 'updated_at'">
            <span class="text-nowrap">
              {{ getDate(props.row.updated_at) }}
            </span>
          </template>
          <span v-else-if="props.column.field === 'actions'">
            <div class="dropdown">
              <button
                class="dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i class="flaticon-dots"></i>
              </button>
              <ul class="dropdown-menu">
                <!-- Historique -->
                <li>
                  <button
                    class="dropdown-item d-flex align-items-center"
                    @click="showDetailSuivi(props.row.id)"
                  >
                    <i class="flaticon-clock lh-1 me-8 position-relative top-1"></i>
                    Historique
                  </button>
                </li>
                <!-- Infos -->
                <li>
                  <button
                    class="dropdown-item d-flex align-items-center"
                    @click="showDetails(props.row)"
                  >
                    <i class="flaticon-view lh-1 me-8 position-relative top-1"></i>
                    Infos
                  </button>
                </li>
                <!-- Modifier -->
                <li>
                  <button
                    class="dropdown-item d-flex align-items-center"
                    @click="showUpdate(props.row)"
                  >
                    <i class="flaticon-pen lh-1 me-8 position-relative top-1"></i>
                    Modifier
                  </button>
                </li>
                <!-- Supprimer -->
                <li>
                  <button
                    class="dropdown-item d-flex align-items-center text-danger"
                    title="Supprimer Colis"
                  >
                    <i class="flaticon-trash lh-1 me-8 position-relative top-1"></i>
                    Supprimer
                  </button>
                </li>
              </ul>
            </div>
          </span>
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>
    </div>
  </div>

  <!-- <b-modal
      id="modal-detailSuivi"
      title="Détails du suivi"
      cancel-variant="outline-secondary"
      size="lg"
      hide-footer
    >
      <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing" no-body style="max-height: 300px;">
        <b-table responsive :items="DetailsColis" :fields="fields" class="mb-0">
          <template #cell(parcel_code)="data">
            <b>{{ data.value }}</b>
          </template>
          <template #cell(situation)="data">
            <b-badge
              pill
              :variant="`light-${resolveUserStatusVariant(data.value)}`"
              class="text-capitalize"
            >
              {{ resolveStatuParcel(data.value) }}
            </b-badge>
          </template>
          <template #cell(s_name)="data">
            <div
              v-if="
                data.item.status == 'IN_PROGRESS' &&
                data.item.status_second &&
                data.item.status_second != null
              "
              class="rounded-pill fs-13 badge text-bg-black custom-badge"
              :style="{
                '--dynamic-bg': globalStore.globalHelper(data.item.status_second).code_color,
              }"
            >
              {{ globalStore.globalHelper(data.item.status_second).name }}
            </div>
            <div
              v-else
              class="rounded-pill fs-13 badge text-bg-black custom-badge"
              :style="{ '--dynamic-bg': data.item.code_color }"
            >
              {{ data.value }}
            </div>
          </template>
          <template #cell(created_at)="data">
            <span class="text-nowrap" v-if="data.item.created_at">
              {{ getDate(data.value) }}
            </span>
          </template>
          <template #cell(city_name)="data">
            <ul>
              <li v-if="data.item.city_name">
                <span class="text-nowrap"><b>Ville: </b> {{ data.item.city_name }}</span>
              </li>
              <li v-if="data.item.data && data.item.data != 0 && data.item.datas.length==0">
                <span class="text-nowrap">{{ data.item.data }}</span>
              </li>
              <li v-if="data.item.livreur_name && data.item.livreur_phone">
                <span class="text-nowrap"
                  ><b>Livreur : </b>{{ data.item.livreur_name }} <b>/</b>
                  {{ data.item.livreur_phone }}
                </span>
              </li>
               <li v-if="data.item.datas && data.item.datas.length != 0">
                <ul style="list-style-type:circle" v-for="(data,index) in data.item.datas" :key="index">
                  <li>{{data.data}} - <b>{{getDate(data.created_at)}}</b></li>
              
                </ul>
              </li>
            </ul>
          </template>
          <template #cell(comment)="data">
            <p>
              <b>{{ data.value }}</b>
            </p>
          </template>
          <template #cell(history_by)="data">
            <span class="text-nowrap">
              {{ data.value }}
            </span>
          </template>
          
        </b-table>
      </div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
  </b-modal>
   <b-modal
      id="modal-details"
      title="Information du colis."
      cancel-variant="outline-secondary"
      size="lg"
      hide-footer
    >
     
        <b-row>

      <b-col
        cols="21"
        xl="6"
        class="d-flex justify-content-between flex-column"
      >
         <table class="mt-2 mt-xl-0 w-100">
          <tr>
            <th class="pb-50">
              <feather-icon
                icon="UserIcon"
                class="mr-75 icons"
              />
              <span class="font-weight-bold">Client :</span>
            </th>
            <td class="pb-50 details">
            {{ColiDetails.customer_name}}
            </td>
          </tr>
          <tr>
            <th class="pb-50">
              <feather-icon
                icon="PhoneIcon"
                class="mr-75 icons"
              />
              <span class="font-weight-bold">Téléphone :</span>
            </th>
            <td class="pb-50 details text-capitalize">
            {{ColiDetails.customer_phone}}
            </td>
          </tr>
        </table>
       
      </b-col>

      <b-col
        cols="12"
        xl="6"
      >
        <table class="mt-2 mt-xl-0 w-100">
          <tr>
            <th class="pb-50">
              <feather-icon
                icon="KeyIcon"
                class="mr-75 icons"
              />
              <span class="font-weight-bold">Code d'envoi :</span>
            </th>
            <td class="pb-50 details">
             {{ColiDetails.code}}
            </td>
          </tr>
          <tr>
            <th class="pb-50">
              <feather-icon
                icon="UserCheckIcon"
                class="mr-75 icons"
              />
              <span class="font-weight-bold">Destinataire :</span>
            </th>
            <td class="pb-50 text-capitalize details">
               {{ColiDetails.receiver}}
            </td>
          </tr>
          <tr>
            <th class="pb-50">
              <feather-icon
                icon="PhoneCallIcon"
                class="mr-75 icons"
              />
              <span class="font-weight-bold">Téléphone :</span>
            </th>
            <td class="pb-50 text-capitalize details">
                 {{ColiDetails.phone}}
            </td>
          </tr>
          <tr>
            <th class="pb-50">
              <feather-icon
                icon="MessageCircleIcon"
                class="mr-75 icons"
              />
              <span class="font-weight-bold">Commentaire :</span>
            </th>
            <td class="pb-50 details">
                {{ColiDetails.note}}
            </td>
          </tr>
          <tr>
            <th>
              <feather-icon
                icon="MapIcon"
                class="mr-75 icons"
              />
              <span class="font-weight-bold">Adresse :</span>
            </th>
            <td class="details">
                {{ColiDetails.address}}
            </td>
          </tr>
           <tr>
            <th class="pb-50">
              <feather-icon
                icon="MapPinIcon"
                class="mr-75 icons"
              />
              <span class="font-weight-bold">Ville :</span>
            </th>
            <td class="pb-50 details">
                {{ColiDetails.city_name}}
            </td>
          </tr>
           <tr>
            <th class="pb-50">
              <feather-icon
                icon="BoxIcon"
                class="mr-75 icons"
              />
              <span class="font-weight-bold">Produit :</span>
            </th>
            <td class="pb-50 details">
                {{ColiDetails.product_nature}}
            </td>
          </tr>
           <tr>
            <th class="pb-50">
              <feather-icon
                icon="DollarSignIcon"
                class="mr-75 icons"
              />
              <span class="font-weight-bold">Crbt :</span>
            </th>
            <td class="pb-50 details">
                {{ColiDetails.price}} Dhs
            </td>
          </tr>
        </table>
      </b-col>
    </b-row>
      
  </b-modal>
  <b-modal
      id="modal-update"
      title="Modifier Coli"
      ok-title="Enregistrer"
      @ok="EditColi"
      cancel-title="Annuler"
      cancel-variant="outline-secondary"
      size="lg"
    >
      <b-form>
        <b-row>
          <b-col
          cols="12"
          >
          <hr/>
          </b-col>
        </b-row>

        <b-row>
          <b-col
          cols="12"
          md="6"
          >
          <b-form-group
          label="Destinataire"
          label-for="dest"
        >
          <b-form-input
            id="dest"
            v-model="form.receiver"

          />
        </b-form-group>
         
          </b-col>
          <b-col
          cols="12"
          md="6"
          >
         <b-form-group
          label="Téléphone"
          label-for="phone"
        >
          <b-form-input
            id="phone"
            v-model="form.phone"
          />
        </b-form-group>
        </b-col>
        <b-col
          cols="12"
          >
         <b-form-group
          label="Ville"
          label-for="city"
        >
          <v-select
          id="customer"
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          label="name"
          v-model="city"
          placeholder="Ville"
          :options="CitiesList"
        />
        </b-form-group>
        </b-col>
        <b-col
          cols="12"
          md="6"
          >
         <b-form-group
          label="Adresse"
          label-for="adresse"
        >
          <b-form-textarea
              name="adresse"
              rows="3"
              v-model="form.address"
          />
        </b-form-group>
        </b-col>
        <b-col
          cols="12"
          md="6"
          >
         <b-form-group
          label="Commentaire"
          label-for="comment"
        >
        <b-form-textarea
              name="comment"
              rows="3"
              v-model="form.note"
          />
         
        </b-form-group>
        </b-col>
        <b-col
          cols="12"
          md="3"
          >
         <b-form-group
          label="Prix"
          label-for="price"
        >
          <b-form-input
            id="price"
            v-model="form.price"
          />
        </b-form-group>
        </b-col>
        <b-col
          cols="12"
          md="3"
          >
         <b-form-group
          label="Frais de livraison *"
          label-for="fl"
        >
          <b-form-input
            id="fl"
            v-model="form.delivered_fees"
          />
        </b-form-group>
        </b-col>
        <b-col
          cols="12"
          md="3"
          >
         <b-form-group
          label="Frais de retour *"
          label-for="frn"
        >
          <b-form-input
            id="frn"
            v-model="form.returned_fees"
          />
        </b-form-group>
        </b-col>
        <b-col
          cols="12"
          md="3"
          >
         <b-form-group
          label="Frais de refus *"
          label-for="frs"
        >
          <b-form-input
            id="frs"
            v-model="form.refused_fees"
          />
        </b-form-group>
        </b-col>
        </b-row>
      </b-form>
  </b-modal> -->
</template>

<script lang="ts">
import { onMounted, reactive , ref, watch} from 'vue'
import { defineComponent } from 'vue'
import api from "@/utils/axios";
import { useAppToast } from "@/composables/useAppToast";
import { useGlobalStore } from "@/stores/global";
import { useAuthStore } from "@/stores/auth";
import moment from 'moment';


export default defineComponent({
    props: {
    noteRow: {
      type: Object,
      required: true,
    },
    getRecords: {
      type: Function,
    },
    isOpen:{
      type: Boolean,
    }
  },
  setup(props) {
    // Import Vue's reactivity helpers if needed
    // import { ref, reactive } from 'vue'
    // import Form from 'path-to-your-form-class'
  const { showToast } = useAppToast();
    const auth = useAuthStore();
    const user = auth.user;
    const globalStore = useGlobalStore();

    const note_BR = ref(props.noteRow);


    const isLoader = ref(true)
    const columns = ref([
      { label: "Code Suivi", field: "code" },
      { label: "Client", field: "receiver" },
      { label: "Date de ramassage", field: "updated_at" },
      { label: "Prix", field: "price" },
      { label: "Ville", field: "city_name" },
      { label: "Actions", field: "actions" },
    ])
    const fields = ref([
      { key: "parcel_code", label: "Code d'envoi" },
      { key: "situation", label: "Etat" },
      { key: "s_name", label: "Status" },
      { key: "created_at", label: "Date", tdClass: 'browserclass' },
      { key: "city_name", label: "Informations" },
      { key: "name", label: "Action par" },
    ])
    const SelectedRows = ref([])
    const SelectedNewRows = ref([])
    const codeColis = ref('')
    const refreception = ref('')
    const rows1 = ref([])
    const rows2 = ref([])
    const reception = ref<any>({});
    const ColiDetails = ref<any>({});
    const DetailsColis = ref([])
    const city = ref({ id: 0, name: null })
    const CitiesList = ref([])
    // Make sure Form is imported or defined
    const form = reactive({
      id: 0,
      code: '',
      price: '',
      phone: '',
      delivered_fees: '',
      returned_fees: '',
      refused_fees: '',
      receiver: '',
      address: '',
      note: '',
    });
    const searchTerm = ref('')
    const searchTerm1 = ref('')


    // Format date using moment.js
    function getDate(value: string) {
      return moment.utc(String(value)).format("YYYY-MM-DD HH:mm");
    }

    // Search for a parcel by code
    async function SearchColis() {
      const data = new FormData();
      data.append('ref_note', reception.value.note_ref);
      data.append('code_colis', codeColis.value);
      data.append('UserID', JSON.parse(localStorage.getItem('userData') || '{}').id);

      try {
      const res = await api.post('/api/auth/AddColiPickedUp', data);
      isLoader.value = false;
      codeColis.value = '';
      if (res.data.message === "success") {
        const audio = new Audio('/src/assets/success.mp3');
        audio.play();
        getData();
        props.getRecords();
      } else if (res.data.message === 'not exist') {
        const audio = new Audio('/src/assets/erro.mp3');
        audio.play();
       showToast('Vous ne pouvez pas l\'ajouter', 'error');
      } else if (res.data.message === 'error edit') {
        const audio = new Audio('/src/assets/erro.mp3') ;
        audio.play();
        showToast('Vous ne pouvez pas modifier ce bon', 'error');
      }
      } catch (error) {
      showToast('Une erreur est survenue', 'error');
        
      }
    }

    // Selection handlers
    function onSelectAll(params: any) {
      SelectedRows.value = params.selectedRows;
    }
    function selectionChanged(params: any) {
      SelectedRows.value = params.selectedRows;
    }
    function onSelectAllColis(params: any) {
      SelectedNewRows.value = params.selectedRows;
    }
    function selectionChangedColis(params: any) {
      SelectedNewRows.value = params.selectedRows;
    }

    // Fetch data for the note and parcels
    async function getData() {
      isLoader.value = true;
      try {
      const receptionRes = await api.get('/api/auth/GetNoteRecp', { params: { ref: note_BR.value.note_ref } });
      reception.value = receptionRes.data;

      const waitingRes = await api.get('/api/auth/ColisWaitingInNote', { params: { ref: note_BR.value.note_ref } });
      rows1.value = waitingRes.data;

      const pickedRes = await api.get('/api/auth/ColisPickedInNote', { params: { ref: note_BR.value.note_ref } });
      rows2.value = pickedRes.data;
      } catch (error) {
      // Handle error if needed
      }
      isLoader.value = false;
    }

    // Status variant resolver
    function resolveUserStatusVariant(status: string) {
      if (status === 'PICKED_UP') return 'warning';
      if (status === 'DELIVERED') return 'success';
      if (status === 'PAID') return 'info';
      if (status === 'NOT_PAID') return 'danger';
      return 'primary';
    }

    // Show parcel tracking details
    async function showDetailSuivi(id: number) {
      try {
      const res = await api.get(`/api/auth/get_Coli_Suivi/${id}`);
      DetailsColis.value = res.data;
      } catch (error) {
      showToast('Something went wrong! Please try again', 'error');
      }
    }

    // Show parcel details
    function showDetails(row: any) {
      ColiDetails.value = row;
    }

    // Show update modal and fill form
    function showUpdate(coli: any) {
      Object.assign(form, {
      id: coli.id,
      code: coli.code,
      price: coli.price,
      phone: coli.phone,
      delivered_fees: coli.delivered_fees,
      returned_fees: coli.returned_fees,
      refused_fees: coli.refused_fees,
      receiver: coli.receiver,
      address: coli.address,
      note: coli.note,
      });
      city.value.name = coli.city_name;
      city.value.id = coli.city_id;
    }

    // Edit parcel
    async function EditColi() {
      const data = new FormData();
      data.append('code', form.code);
      data.append('city_name', city.value.name);
      data.append('city_id', String(city.value.id));
      data.append('price', form.price);
      data.append('phone', form.phone);
      data.append('address', form.address);
      data.append('note', form.note);
      data.append('delivered_fees', form.delivered_fees);
      data.append('returned_fees', form.returned_fees);
      data.append('refused_fees', form.refused_fees);
      data.append('receiver', form.receiver);

      try {
      const res = await api.post(`/api/auth/coli_edit/${form.id}`, data);
      if (res.data.message === 'success') {
        showToast( 'Les données sont bien sauvegardés', 'success');
        getData();
      }
      } catch (error) {
      showToast('Une erreur est survenue', 'error');
      }
    }

     onMounted(() => {

      console.log("open", props);
      if (props.isOpen) {
        getData();
      }
    });

    watch(
      () => props.noteRow,
      (newVal) => {
        if (newVal && Object.keys(newVal).length > 0) {
          console.log("note_BR updated:", newVal);
          getData();
        }
      },
      { immediate: true }
    );



    return {
      isLoader,
      columns,
      fields,
      SelectedRows,
      SelectedNewRows,
      codeColis,
      refreception,
      rows1,
      rows2,
      reception,
      ColiDetails,
      DetailsColis,
      city,
      CitiesList,
      form,
      searchTerm,
      searchTerm1,
      globalStore,
      getDate,
      resolveUserStatusVariant,
      SearchColis,
      onSelectAll,
      selectionChanged,
      onSelectAllColis,
      selectionChangedColis,
      showDetailSuivi,
      showDetails,
      showUpdate,
      user,
      auth

    };
  }
});

</script>

